import translatePoints from './translatePoints.js';

// Higher-order function for translating points.
const translatePointsBy = (x, y) => points =>
  translatePoints(points, x, y);

export default translatePointsBy;